import { STATUS_MAP, DEFAULT_TIMER_DURATION, STATUS_WITH_AUTO_TIMER, CARACTERES_MAXIMOS_SHOW_AUTO_TIMER } from './config.js';
import { handleIntervalTemporizadorToast } from './timer.js';
import { generateContentTemplate, generateProgressBarTemplate, generateToastTemplate } from './templates.js';
import { close_toast } from './close.js';

export function exibe_mensagem_com_status(mensagem, status, title, temporizador = null, actionButton = null) {
  const existingToast = $('.maino-toast');
  if (existingToast.length) {
    const existingTimer = existingToast.data('timer');
    if (existingTimer) {
      clearInterval(existingTimer);
    }
    existingToast.remove();
  }

  const statusConfig = STATUS_MAP[status] || STATUS_MAP.info;
  const { classe, titulo, icon, colorIcon } = statusConfig;

  let temporizadorToast;
  const mostraAutoTimer = STATUS_WITH_AUTO_TIMER.includes(status) && mensagem.length <= CARACTERES_MAXIMOS_SHOW_AUTO_TIMER;
  if (mostraAutoTimer) {
    temporizadorToast = DEFAULT_TIMER_DURATION;
  } else {
    temporizadorToast = temporizador;
  }

  const content = generateContentTemplate({
    colorIcon,
    icon,
    title: title || titulo,
    mensagem,
    hasTimer: !!temporizadorToast,
    actionButton
  });

  const barraProgresso = temporizadorToast 
    ? generateProgressBarTemplate(colorIcon)
    : '';

  const componente = generateToastTemplate({
    classe,
    content,
    barraProgresso,
    hasTimer: !!temporizadorToast
  });

  $('#alerts').html(componente);

  if (temporizadorToast) {
    return new Promise((resolve) => {
      const handleClose = () => {
        close_toast().then(() => {
          resolve();
        });
      };

      const updateProgress = (percent) => {
        const progressBarInner = $('.maino-toast .progress-bar-inner');
        if (progressBarInner.length) {
          progressBarInner.css('width', `${percent}%`);
        }
      };

      const timer = handleIntervalTemporizadorToast(
        temporizadorToast,
        updateProgress,
        handleClose
      );

      $('.maino-toast').data('timer', timer);
    });
  }
}
